module.exports = __webpack_public_path__ + "static/media/foot.7c5918c5.png";